import { render, staticRenderFns } from "./compareBar.vue?vue&type=template&id=23b96501&scoped=true&"
import script from "./compareBar.vue?vue&type=script&lang=js&"
export * from "./compareBar.vue?vue&type=script&lang=js&"
import style0 from "./compareBar.vue?vue&type=style&index=0&id=23b96501&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b96501",
  null
  
)

export default component.exports